<template>
  <div class="row">
    <div class="col-12 mt-2" v-if="cartoes.length > 0 && !usarOutroCartao">
      <div class="row mb-3 g-3">
        <span class="text-center">
          <small>
            Selecione um cartão crédito ou informe cartão crédito novo.
          </small>
        </span>
      </div>
      <carousel :per-page="1" :perPageCustom="[
        [720, 2],
        [991, 3],
        [1500, 4]
      ]" :mouse-drag="true" :autoplay="false" :loop="true" :speed="500">

        <slide v-for="(item, index) in  cartoes " :key="index" class="m-1">

          <div class="card card-cartao p-2" @click="selecionarCartao(item)"
            :class="cartaoToken && item.codigoCartao == cartaoToken.codigoCartao ? 'card-selecionado' : ''">
            <div class="img-box">
              <img :src="icons[item.bandeira]" alt="AMEX" />
            </div>
            <div class="number">
              <label class="fw-bold" for="">**** **** **** {{ item.ultimosDigitos.replace('(não verificado)', '')
              }}</label>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <small><span class="fw-bold"></span><span>{{ item.nomeImpresso }}</span></small>
              <span class="fw-bold icon">
                <a class="btn" @click="excluirCartao(item)">
                  <i class="fa-solid fa-trash-can"></i>
                </a>
              </span>
            </div>

            <div v-if="cartaoToken && cartaoToken.codigoCartao == item.codigoCartao">
              <i class="fa-solid fa-check"></i>
              <span class="m-2">
                <small>selecionado
                </small>
              </span>

            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <div class="col-12 mt-3" v-if="cartoes.length == 0 || usarOutroCartao">
      <div class="card p-3">
        <p class="mb-0 fw-bold">Informe os dados do cartão</p>
        <div class="row d-flex  m-3 mr-2">

          <div class="col-lg-8">
            <form @submit.prevent="salvarCartao()" class="form">
              <div class="row">
                <div class="col-12">
                  <div class="form__div">
                    <label for="" class="">Nome impresso*</label>
                    <input type="text" class="form-control" name="customerName" placeholder=" "
                      v-model="cartao.customerName" required>

                  </div>
                </div>
                <div class="col-12">
                  <div class="form__div">
                    <label for="" class="">Número do cartão*</label>
                    <input type="text" class="form-control" placeholder=" " name="cardNumber" v-model="cartao.cardNumber"
                      v-mask="['#### #### #### ####']" required>

                  </div>
                </div>
                <div class="col-8">

                  <div class="form__div">
                    <label for="" class="">Validade*</label>
                    <input type="text" class="form-control" placeholder=" " name="valid" v-model="cartao.valid"
                      v-mask="['##/##']" required>

                  </div>
                </div>

                <div class="col">
                  <div class="form__div">
                    <label for="">CVV*</label>
                    <input type="password" class="form-control" placeholder=" " name="securityCode"
                      v-model="cartao.securityCode" v-mask="['###']" required>

                  </div>
                </div>
              </div>
              <button ref="submit" style="display:none;"></button>
            </form>
          </div>
          <div class=" col ml-3">
            <div class="row d-flex align-items-center justify-content-between">
              <div class="col">
                <div class="img-box">
                  <img :src="icons['MASTERCARD']" alt="MASTERCARD" />
                </div>
              </div>
              <div class="col">
                <div class="img-box">
                  <img :src="icons['VISA']" alt="VISA" />
                </div>
              </div>
              <div class="col">
                <div class="img-box">
                  <img :src="icons['ELO']" alt="ELO" />
                </div>
              </div>
              <div class="col">
                <div class="img-box">
                  <img :src="icons['AMEX']" alt="AMEX" />
                </div>
              </div>

              <div class="col">
                <div class="img-box">
                  <img :src="icons['DISCOVER']" alt="DISCOVER" />
                </div>
              </div>
              <div class="col">
                <div class="img-box">

                </div>
              </div>
            </div>

            <div class="row d-flex mt-3">
              <span class="col text-center icon-seguro">
                <i class="fa-solid fa-lock"></i>
                <span class="ml-1"> Ambiente seguro</span>

              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="erro" class=" row  col-12  my-2 badge-danger text-center p-3 text-uppercase mt-3">
      {{ erro }}
    </div>
    <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
      <button type="button" class="btn btn_color_system py-2 px-5 mt-4" @click="$router.go(-1)">
        VOLTAR
      </button>
      <button v-if="cartoes.length > 0" type="button" class="btn btn_color_system py-2 px-5 mt-4"
        @click="usarOutroCartao = !usarOutroCartao">
        <i class="fa-solid fa-credit-card"></i>
        <span class="ml-1" v-if="!usarOutroCartao">
          <small>
            USAR OUTRO CARTÃO
          </small>
        </span>
        <span class="ml-1" v-else>
          <small>
            USAR CARTÃO CADASTRADO
          </small>
        </span>
      </button>
      <button class="btn btn_color_system py-2 px-5 mt-4" type="button" @click="finalizarAssinatura()">
        FINALIZAR
      </button>
    </div>

    <Loading v-if="loading" :textoMensagem="mensagemLoading"></Loading>
  </div>
</template>

<script>

import icons from "@/shared/components/SvgIcon.js";

import Loading from "@/components/Loading.vue";
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "CheckoutCartao",
  components: { Loading },
  props: [],
  data() {
    return {
      icons,
      plano: {
        modeloCobranca: {}
      },
      cartao: {},
      usarOutroCartao: false,
      cartaoToken: null,
      cartoes: [],
      loading: true,
      mensagemLoading: "Estamos processanto sua solicitação. Por favor, aguarde um momento.",
      detail: null,
      erro: null,

    };
  },
  mounted() {
    this.loading = false;
    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }
    //this.getListaCartoes();
    //this.loadDetailRecorrencia(this.plano.recorrenciaId);
  },
  methods: {
    loadDetailRecorrencia(recorrenciaId) {
      if (recorrenciaId) {
        this.loading = true;
        apiService
          .obterDetalhePagamentoRecorrente(recorrenciaId)
          .then((response) => {
            this.detail = response;
            this.loading = false;
          }).catch((error) => {
            this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
            this.loading = false;
          })
      }
    },
    salvarCartao() {
      this.loading = true;
      const _valid = this.cartao.valid.split("/");
      this.cartao.month = _valid[0];
      this.cartao.year = _valid[1];

      apiService.cadastrarCartaoSemForm(this.cartao)
        .then((res) => {
          if (res.success) {
            apiService.getCartao(res.result)
              .then((res) => {
                this.cartaoToken = res;
                this.finalizarAssinatura()
              }).catch((error) => {
                this.erro = error.response.data.message;
                this.loading = false;
              })
          } else {
            this.erro = res.message;
            this.loading = false;
          }
        }).catch((error) => {
          this.erro = error.response.data.message;
          this.loading = false;
        })
    },

    finalizarAssinatura() {
      this.erro = '';
      if (!this.cartaoToken) {
        if (this.cartoes.length == 0 || this.usarOutroCartao) {
          this.$refs.submit.click()
        } else {
          this.erro = 'Selecione um cartão crédito ou cadastre um novo.';
        }
      } else {

        this.loading = true;
        apiService
          .selecionaMeioPagamento(this.plano.recorrenciaId, this.cartaoToken)
          .then(res => {
            if (res.statusBoolean) {
              apiService
                .aceitarPagamento(this.detail)
                .then(() => {
                  if (window.PIXEL_CODE) {
                    window.fbq("track", "Purchase", {
                      value: this.detail.valorParcela,
                      currency: "BRL",
                      predicted_ltv: "0.00",
                      content_name: this.detail.nome,
                    });
                  }
                  localStorage.removeItem("simulacao-plano");
                  this.$router.push(`/planos/simulador-step-4`);
                }).catch((error) => {
                  this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
                })
                .finally(() => (this.loading = false));
            }
          }).catch((error) => {

            this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
            console.log(this.erro);
            this.loading = false;
          })
      }
    },
    selecionarCartao(cartaoSelecionado) {

      if (!this.cartaoToken || this.cartaoToken.codigoCartao !== cartaoSelecionado.codigoCartao) {
        this.cartaoToken = cartaoSelecionado;
      } else {
        this.cartaoToken = null
      }
    },

    excluirCartao(cartao) {
      this.$swal({
        title: "Tem certeza de que quer excluir o cartão?",
        html: `<div class="pt-3"> **** **** **** ${cartao.ultimosDigitos.replace("(não verificado)", "")}</div><small>${cartao.bandeira}</small>`,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => {
          this.loading = true;
          apiService.removerCartao(cartao.codigoCartao).then(() => {
            apiService.getListaCartoes().then((resCartao) => {
              this.cartoes = resCartao;
              this.cartaoToken = null;
            });
          }).catch((error) => {
            this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
          })
            .finally(() => (this.loading = false));
        },
      });
    },
    getListaCartoes() {
      this.loading = true;
      apiService.getListaCartoes().then((res) => {
        this.cartoes = res;

        for (let i = 0; i < this.cartoes.length; i++) {
          let cartao = this.cartoes[i];
          if (cartao.codigoCartao == this.cartaoToken.codigoCartao) {
            this.cartaoToken = cartao;
          }
        }
        if (!this.cartaoToken && this.cartoes.length > 0) {
          this.cartaoToken = this.cartoes[0];
        }

      }).catch((error) => {
        this.erro = error.response.data;
      })
    },
    selecionaMeioPagamento() {
      if (this.cartaoToken) {
        this.loading = true;
        apiService
          .selecionaMeioPagamento(this.assinaturaId, this.cartaoToken)
          .then(res => {
            if (res.statusBoolean) {
              this.aceitarPagamento();
            }
          }).catch((error) => {
            this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
            this.loading = false;
          })
      } else {
        this.erro = { title: 'Selecione um cartão de crédito.' }
      }
    },
    aceitarPagamento() {
      this.loading = true;
      apiService
        .aceitarPagamento(this.detail)
        .then(() => {
          if (window.PIXEL_CODE) {
            window.fbq("track", "Purchase", {
              value: this.detail.valorParcela,
              currency: "BRL",
              predicted_ltv: "0.00",
              content_name: this.detail.nome,
            });
          }

        }).catch((error) => {
          this.erro = 'Erro: ' + error.response.data.code + ' - ' + error.response.data.title;
        })
        .finally(() => (this.loading = false));
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    }
  }
};
</script>
<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif
}

.container {
  margin: 30px auto;
}

.container .card {
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  background: #fff;
  border-radius: 1px;
}

body {
  background: #eee
}



.btn.btn-primary {
  background-color: #ddd;
  color: black;
  box-shadow: none;
  border: none;
  font-size: 20px;
  width: 100%;
  height: 100%;
}

.btn.btn-primary:focus {
  box-shadow: none;
}

.container .card .img-box {
  max-width: 50px;

}

.container .card img {
  width: 100%;
  object-fit: fill;
}

.container .card .number {
  font-size: 24px;
}

.container .card-body .btn.btn-primary .fab.fa-cc-paypal {
  font-size: 32px;
  color: #3333f7;
}

.fab.fa-cc-amex {
  color: #1c6acf;
  font-size: 32px;
}

.fab.fa-cc-mastercard {
  font-size: 32px;
  color: red;
}

.fab.fa-cc-discover {
  font-size: 32px;
  color: orange;
}

.c-green {
  color: green;
}

.box {
  height: 40px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ddd;
}

.btn.btn-primary.payment {
  background-color: #1c6acf;
  color: white;
  border-radius: 0px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}


.form__div {
  height: 50px;
  position: relative;
  margin-bottom: 24px;
  margin-left: 10px;
}

.form-control {
  width: 100%;
  height: 45px;
  font-size: 14px;
  border: 1px solid #DADCE0;
  border-radius: 0;
  outline: none;
  padding: 2px;
  background: none;
  z-index: 1;
  box-shadow: none;
}

.form__label {
  position: absolute;
  left: 16px;
  top: 10px;
  background-color: #fff;
  color: #80868B;
  font-size: 16px;
  transition: .3s;
  text-transform: uppercase;
}

.form-control:focus+.form__label {
  top: -8px;
  left: 12px;
  color: #1A73E8;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.form-control:not(:placeholder-shown).form-control:not(:focus)+.form__label {
  top: -8px;
  left: 12px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
}

.form-control:focus {
  border: 1.5px solid #1A73E8;
  box-shadow: none;
}

.icon-seguro {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  transition: 0.5s;
  color: var(--cor-principal);
  overflow: hidden;
}

.card-selecionado {
  border-color: var(--cor-principal);
}

.card-cartao {
  border-radius: 10px !important;
  width: 80% !important;
}
</style>
